import DOMPurify from 'dompurify';

/**
 * Payment Form Sanitizer
 * Sanitizes HTML content for payment forms to prevent XSS attacks
 */

export const sanitizePaymentFormHTML = (html: string): string => {
  // Configure DOMPurify for payment forms
  const config = {
    ALLOWED_TAGS: ['div'],
    ALLOWED_ATTR: ['class'],
    KEEP_CONTENT: false,
    RETURN_DOM: false,
    RETURN_DOM_FRAGMENT: false,
  };

  return DOMPurify.sanitize(html, config);
};

/**
 * Safely initializes payment form container
 * Prevents XSS while allowing Moyasar to inject its form
 */
export const initializePaymentContainer = (element: HTMLDivElement | null): boolean => {
  if (!element) return false;

  try {
    // Sanitize before setting
    const sanitizedHTML = sanitizePaymentFormHTML('<div class="mysr-form"></div>');
    element.innerHTML = sanitizedHTML;
    return true;
  } catch (error) {
    // Use basic console.error since secureLogger might not be ready yet
    if (typeof console !== 'undefined' && console.error) {
      console.error('Failed to initialize payment container:', error);
    }
    return false;
  }
};
